// extracted by mini-css-extract-plugin
export default {"link":"BackLink_link__sYaMm","icon":"BackLink_icon__im0b8"};